import PropTypes from 'prop-types';
import { Icon } from '@unite-us/app-components';

const DEFAULT_ERROR_MESSAGE = 'Oops! Something went wrong.';

function ErrorPage(props) {
  const { error, message } = props;

  const errorCode = error?.response?.status || '';
  const responseMessage = errorCode
    ? `Error Code: ${errorCode}`
    : 'Failed to Load Response Data';

  // Use default message if message is falsy (empty string, null, undefined)
  const displayMessage = message || DEFAULT_ERROR_MESSAGE;

  // Log to Datadog when fallback is used - this could indicate a bug
  if (!message && message !== undefined) {
    window.DD_RUM?.addError(new Error('ErrorPage: Empty message prop provided, using default fallback'));
  }

  return (
    <div className="error-page">
      <Icon
        className="error-page__icon"
        color="black"
        icon="ExclamationTriangle"
        size={80}
      />
      <h1 className="error-page__message">{displayMessage}</h1>
      <span className="error-page__code">{responseMessage}</span>
    </div>
  );
}

ErrorPage.propTypes = {
  error: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.number.isRequired,
    }),
  }),
  message: PropTypes.string,
};

ErrorPage.defaultProps = {
  message: DEFAULT_ERROR_MESSAGE,
  error: null,
};

export default ErrorPage;
